import { useState } from 'react';
import { message, DatePicker, Form, Modal, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useCreateFinancialYear, useGetAllClients } from '../utils/queryUtils';
import { setReloadFinancialYear } from '../store/action/reload';
import { financialYearTypes, periodTypes } from '../consts';

const { Option } = Select;

const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

export default function RequestFy({ visible, setVisible }) {
    const [, setSelectedDate] = useState();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const selectedCompany = useSelector(st => st?.selected?.company || {});
    const [title_id, setTitle_id] = useState();
    const [Abn_id, setAbn_id] = useState();
    const [Client_id, setClient_id] = useState();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const selectedClient = useSelector(st => st.selected?.client || {});
    const selectedPrimaryClient = useSelector((st) => st.selected.primaryClient || {});
    const all_clients_data = useGetAllClients(selectedCompany?.name);
    const all_clients = all_clients_data?.data?.data || [];
    const { mutateAsync: createFinancialYear } = useCreateFinancialYear();

    const handleDateChange = (date) => {
        setSelectedDate(`${dayjs(date).subtract(1, 'year').format('YYYY')}-${dayjs(date).format('YYYY')}`);
        form.setFieldsValue({ financial_year: date });
    };

    async function submit() {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const start = dayjs(values.financial_year).subtract(1, 'year').format("YYYY");
            const end = dayjs(values.financial_year).format("YYYY");

            const res = await createFinancialYear({
                client_id: Client_id || selectedClient?._id,
                company: selectedCompany,
                title: title_id,
                abn: Abn_id,
                fy: `${start}-${end}`,
                start,
                end,
                fy_status: "PROPOSED",
                period_type: values.period_type,
                fy_type: values.fy_type,
                primary_client: selectedPrimaryClient?._id
            });

            if (res) {
                message.success('FY created successfully');
                setVisible(false);
                setSelectedDate();
                dispatch(setReloadFinancialYear(true));
                form.resetFields();
            } else {
                if (res.response === "company_id is required") {
                    message.error("Please add a company before adding a client");
                } else {
                    message.error(res.response);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal
            open={visible}
            onCancel={() => {
                setVisible(false);
                setSelectedDate();
                form.resetFields();
                setData({});
            }}
            title={<h6 className="font-semibold m-0">Create Financial Year</h6>}
            okText="Create Financial Year"
            onOk={submit}
            destroyOnClose
            okButtonProps={{ loading }}
        >
            <Form
                layout="vertical"
                {...layout}
                form={form}
                onFinish={submit}
            >
                <Form.Item
                    label={<div className="finanicalYears"><p style={{ width: "200px", marginBottom: "0px" }}>Entity</p></div>}
                    name="client_id"
                    initialValue={selectedClient?._id || Client_id}
                    rules={[{ required: true, message: 'Please select a client' }]}
                >
                    <Select
                        onChange={(e) => {
                            let selectedclient = all_clients.find((data) => e === data._id);
                            if (selectedclient) {
                                form.setFieldsValue({ Abn: selectedclient.abn });
                                setTitle_id(selectedclient.title);
                                setAbn_id(selectedclient.abn);
                                setClient_id(selectedclient._id);
                            }
                        }}
                        showSearch
                        optionFilterProp="label"
                        placeholder="Select a client"
                    >
                        {all_clients
                            .filter((el) => el.title)
                            .map((e) => (
                                <Option value={e._id} key={e._id} label={e.title}>
                                    {e.title}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Period Type"
                    name="period_type"
                    rules={[{ required: true, message: 'Please select a period type' }]}
                >
                    <Select
                        className="mb-2"
                        style={{ width: '100%' }}
                        placeholder="Select Period Type"
                        onChange={(value) => {
                            setData((prev) => ({ ...prev, period_type: value }));
                        }}
                    >
                        {periodTypes.map((type) => (
                            <Option key={type} value={type}>
                                {type}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Financial Year Type"
                    name="fy_type"
                    rules={[{ required: true, message: 'Please select a financial year type' }]}
                >
                    <Select
                        className="mb-2"
                        style={{ width: '100%' }}
                        placeholder="Select Financial Year Type"
                        value={data.fy_type}
                        onChange={(value) => {
                            setData((prev) => ({ ...prev, fy_type: value, custom_fy_type: '' }));
                            form.setFieldsValue({ fy_type: value });
                        }}
                    >
                        {financialYearTypes.map((type) => (
                            <Option key={type} value={type}>
                                {type}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="financial_year"
                    label="Financial Year"
                    rules={[{ required: true, message: 'Please select a financial year' }]}
                >
                    <div>
                        <style jsx>{`
              .fyyeaR .ant-picker-input > input::placeholder {
                color:#1677ff; 
              }
            `}</style>
                        <DatePicker
                            className="fyyeaR"
                            placeholder="+ Add Fy"
                            onChange={handleDateChange}
                            picker="year"
                            variant="borderless"
                            suffixIcon=""
                        />
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
}
